module Web.UIEvent.WheelEvent.EventTypes where

import Web.Event.Event (EventType(..))

wheel :: EventType
wheel = EventType "wheel"
